import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  Grid,
  GridItem,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field } from "formik";
import { RadioButtonField } from "../../../../../components/RadioButtonField";
import { useState } from "react";

import { CustomSelectWField } from "../../../../../components/CustomSelectWField";

export const VisitaAba = ({ children, props }) => {
  const [faixasPeriodo] = useState({
    options: [
      { id: 1, label: "No Mês" },
      { id: 2, label: "Nos Últimos 3 Meses" },
      { id: 3, label: "Nos Últimos 6 Meses" },
      { id: 4, label: "Em Qualquer Período" },
    ],
    isLoading: false,
  });

  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Visita
        </Text>
        {children}
      </Flex>

      <Box>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Recebe Visita?"}
          mb={4}
          mt={7}
        >
          Recebe Visita?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioRecebeVisita">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioRecebeVisita &&
                    form.touched.radioRecebeVisita
                  }
                  id="radioRecebeVisita"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioRecebeVisita", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-recebeVisita-s"
                        fieldName="radioRecebeVisita"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-recebeVisita-n"
                        fieldName="radioRecebeVisita"
                        value="N"
                        label="Não"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioRecebeVisita}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
      <Box>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <CustomSelectWField
              fieldName="faixaPeriodo"
              label={
                <>
                  Faixa de Período{" "}
                  <Text as="span" fontWeight={700} color="red.500">
                    *
                  </Text>
                </>
              }
              placeholder="Selecione o Universo da Consulta"
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.id}
              options={faixasPeriodo.options}
              onChange={(value) => {
                props.setFieldValue("faixaPeriodo", value ? value : "");
              }}
              isDisabled={
                props?.values?.radioRecebeVisita !== "S" &&
                props?.values?.radioRecebeVisita !== "N"
              }
              visible
            />
          </GridItem>
        </Grid>
      </Box>
    </>
  );
};
